export default __webpack_public_path__ + "static/media/uefa-prediction.35a6fafc.webp";